import React, { useRef } from 'react';
import type { FC } from 'react';
import styled from 'styled-components';

import { useIntersectionObserver } from 'usehooks-ts';

// Models:
import type { ICountryList } from './Models/country-list.model';

export const CountryListDesktop: FC<ICountryList> = (props) => {
  const {
    className,
    linkedCountryList,
    linkedCountryListTitle,
    trackCountryLinkClick,
  } = props;

  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, { freezeOnceVisible: true });
  const isVisible = !!entry?.isIntersecting || !linkedCountryListTitle;

  return (
    <StyledCountryList className={className} ref={ref}>
      {!!linkedCountryListTitle && (
        <StyledTitle>{linkedCountryListTitle}</StyledTitle>
      )}
      <StyledListWrapper>
        {linkedCountryList.map((country) => {
          const { text, link, iso2, onClick } = country;

          return (
            <StyledCountryWrapper key={link}>
              {isVisible && (
                <StyledFlag
                  className={`lt-flag lt-flag-${iso2?.toLowerCase() || 'us'}`}
                />
              )}

              <StyledCountryAnchor
                onClick={() => {
                  trackCountryLinkClick(iso2);

                  if (!onClick) return;
                  onClick();
                }}
                href={link}
              >
                {text}
              </StyledCountryAnchor>
            </StyledCountryWrapper>
          );
        })}
      </StyledListWrapper>
    </StyledCountryList>
  );
};

const StyledCountryList = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 16px;

  border-radius: 4px;
`;

const StyledTitle = styled.h2`
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 16px;
`;

const StyledListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const StyledCountryWrapper = styled.div`
  display: flex;
  flex-basis: 25%;
  align-items: center;
  padding-right: 16px;
  margin-bottom: 8px;
`;

const StyledCountryAnchor = styled.a`
  color: #007aff;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
`;

const StyledFlag = styled.div`
  margin-right: 4px;
`;
